<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M22.5 5.25C22.6989 5.25 22.8896 5.32907 23.0303 5.46973C23.1709 5.61038 23.25 5.80109 23.25 6V18C23.25 18.1989 23.1709 18.3896 23.0303 18.5303C22.8896 18.6709 22.6989 18.75 22.5 18.75H10.0312L10.8975 17.25H18.1543C18.4061 16.3984 18.8672 15.6231 19.4951 14.9951C20.1231 14.3672 20.8984 13.9061 21.75 13.6543V10.3457C20.8984 10.0939 20.1231 9.63284 19.4951 9.00488C18.8672 8.37692 18.4061 7.60162 18.1543 6.75H16.959L17.8252 5.25H22.5ZM13.2061 5.25L12.3398 6.75H5.8457C5.5939 7.60162 5.13284 8.37692 4.50488 9.00488C3.87692 9.63284 3.10162 10.0939 2.25 10.3457V13.6543C3.10162 13.9061 3.87692 14.3672 4.50488 14.9951C5.13284 15.6231 5.5939 16.3984 5.8457 17.25H6.27832L5.41211 18.75H1.5C1.30109 18.75 1.11038 18.6709 0.969727 18.5303C0.829074 18.3896 0.75 18.1989 0.75 18V6C0.75 5.80109 0.829074 5.61038 0.969727 5.46973C1.11038 5.32907 1.30109 5.25 1.5 5.25H13.2061ZM2.25 17.25H4.25391C3.86709 16.3504 3.14959 15.6329 2.25 15.2461V17.25ZM21.75 15.2461C20.8504 15.6329 20.1329 16.3504 19.7461 17.25H21.75V15.2461ZM15.124 9.92676C15.5289 10.5369 15.75 11.2569 15.75 12C15.75 12.7415 15.5301 13.4664 15.1182 14.083C14.7062 14.6996 14.1206 15.181 13.4355 15.4648C12.9061 15.6842 12.3352 15.7755 11.7676 15.7402L12.6934 14.1377C13.0284 14.029 13.3371 13.8445 13.5908 13.5908C14.0128 13.1689 14.25 12.5967 14.25 12C14.25 11.8409 14.2322 11.6833 14.1992 11.5293L15.124 9.92676ZM8.51367 13.376C8.43159 13.168 8.36629 12.9528 8.32227 12.7314C8.1776 12.004 8.25134 11.2496 8.53516 10.5645C8.819 9.87936 9.3004 9.29383 9.91699 8.88184C10.38 8.57255 10.9039 8.371 11.4502 8.29004L8.51367 13.376ZM2.25 6.75V8.75391C3.14959 8.36709 3.86709 7.64959 4.25391 6.75H2.25ZM19.7461 6.75C20.1329 7.64959 20.8504 8.36709 21.75 8.75391V6.75H19.7461Z"
      :fill="fill"
    />
    <path
      d="M16.2434 1.9907C16.5195 1.51267 17.1305 1.34868 17.6086 1.62449C18.0869 1.90063 18.251 2.51241 17.9748 2.9907L7.50024 21.1343C7.22405 21.6124 6.61227 21.7756 6.13403 21.4995C5.656 21.2234 5.49197 20.6124 5.76782 20.1343L16.2434 1.9907Z"
      :fill="fill"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsMoneyCross'
})

defineProps({
  fill: {
    type: String,
    default: '#671CC2'
  }
})
</script>
